import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';

/**
 * Whether this document is eligible to request fullscreen. It is false until the browser has been
 * checked, and stays false where the Fullscreen API is missing (iPhone Safari) or a host page did
 * not allow it on the iframe. The fullscreen target itself is checked when the user clicks.
 */
export function useIsFullscreenAvailable() {
  const $ = _c(2);
  const [isFullscreenAvailable, setIsFullscreenAvailable] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsFullscreenAvailable(!!document.fullscreenEnabled && typeof document.documentElement.requestFullscreen === "function");
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return isFullscreenAvailable;
}